import React, { useState } from 'react';
import { DatePicker } from 'antd';
import './CustomRangePicker.css';

const { RangePicker } = DatePicker;

const CustomRangePicker = ({ setDataInicio, setDataFim, resetSearch, id }) => {
  const [inicioSelecionado, setInicioSelecionado] = useState(null);
  const [fimSelecionado, setFimSelecionado] = useState(null);

  const atualizarInicio = (data) => {
    let proximoFim = fimSelecionado;

    // Se a nova data inicial ficar depois da final, limpa a final para evitar
    // um período inválido e deixa o usuário escolher novamente.
    if (data && proximoFim && data.isAfter(proximoFim, 'day')) {
      proximoFim = null;
      setFimSelecionado(null);
      setDataFim(null);
    }

    setInicioSelecionado(data || null);
    setDataInicio(data?.format('YYYY-MM-DD') || null);

    if (!data) resetSearch(id);
  };

  const atualizarFim = (data) => {
    setFimSelecionado(data || null);
    setDataFim(data?.format('YYYY-MM-DD') || null);

    if (!data) resetSearch(id);
  };

  const atualizarIntervalo = (dates) => {
    if (!dates) {
      setInicioSelecionado(null);
      setFimSelecionado(null);
      resetSearch(id);
      setDataInicio(null);
      setDataFim(null);
      return;
    }

    const inicio = dates?.[0] || null;
    const fim = dates?.[1] || null;

    setInicioSelecionado(inicio);
    setFimSelecionado(fim);
    setDataInicio(inicio?.format('YYYY-MM-DD') || null);
    setDataFim(fim?.format('YYYY-MM-DD') || null);
  };

  return (
    <div className="custom-date-range-picker">
      <div className="date-range-desktop">
        <RangePicker
          className="custom-date-range-input"
          format="DD/MM/YYYY"
          placeholder={["Data Inicial", "Data Final"]}
          value={inicioSelecionado || fimSelecionado ? [inicioSelecionado, fimSelecionado] : null}
          onChange={atualizarIntervalo}
        />
      </div>

      <div className="date-range-mobile">
        <DatePicker
          className="custom-date-single-input"
          format="DD/MM/YYYY"
          placeholder="Data Inicial"
          value={inicioSelecionado}
          inputReadOnly
          onChange={atualizarInicio}
          disabledDate={(data) => Boolean(fimSelecionado && data && data.isAfter(fimSelecionado, 'day'))}
        />
        <DatePicker
          className="custom-date-single-input"
          format="DD/MM/YYYY"
          placeholder="Data Final"
          value={fimSelecionado}
          inputReadOnly
          disabled={!inicioSelecionado}
          onChange={atualizarFim}
          disabledDate={(data) => Boolean(inicioSelecionado && data && data.isBefore(inicioSelecionado, 'day'))}
        />
      </div>
    </div>
  );
};

export default CustomRangePicker;
